import script from "./FooterView.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterView.vue?vue&type=script&lang=ts&setup=true"

import "./FooterView.vue?vue&type=style&index=0&id=46513855&scoped=true&lang=less"

import exportComponent from "D:\\myWork\\番顺茶叶官网\\panshunwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46513855"]])

export default __exports__